import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { handleServerCoverageListData } from '../../utils/coverage';
export var handleOrganizationCompanyRegions = function handleOrganizationCompanyRegions(regions) {
  return (regions || []).map(function (item) {
    var _item$currency, _item$currency2;

    item.currency = _objectSpread(_objectSpread({}, item.currency), {}, {
      value: item === null || item === void 0 ? void 0 : (_item$currency = item.currency) === null || _item$currency === void 0 ? void 0 : _item$currency.code,
      label: item === null || item === void 0 ? void 0 : (_item$currency2 = item.currency) === null || _item$currency2 === void 0 ? void 0 : _item$currency2.name
    });
    item.countries = (item.countries || []).map(function (aItem) {
      return _objectSpread(_objectSpread({}, aItem), {}, {
        value: aItem.code,
        label: aItem.name
      });
    });
    item.coverages = handleServerCoverageListData(item.coverages);
    item.setGlobalCountry = !!item.is_global;
    item.restOfWorld = !!item.rest_of_world;
    return item;
  });
};